export class Chat {
  len = 0;
  ditandai = false;
  visible = true;

  clone() {
    const newChat = new Chat(
      this.id,
      this.no_tiket,
      this.status,
      JSON.parse(JSON.stringify(this.messages)),
      JSON.parse(JSON.stringify(this.perusahaan)),
      JSON.parse(JSON.stringify(this.pengaduan))
    );

    newChat.ditandai = this.ditandai;

    return newChat;
  }

  constructor(id, no_tiket, status, messages, perusahaan, pengaduan) {
    this.id = id;
    this.no_tiket = no_tiket;
    this.status = status;
    this.messages = messages;
    this.perusahaan = perusahaan;
    this.pengaduan = pengaduan;
    this.len = messages.length;
  }

  getmessage() {
    return this.messages;
  }

  getinfochat() {
    return {
      id: this.id,
      no_tiket: this.no_tiket,
      status: this.no_tiket,
    };
  }

  getinfoperusahaan() {
    return this.perusahaan;
  }

  getpengaduan() {
    return this.pengaduan;
  }

  updatemessage(data) {
    const setupdata = this.setupdata(data)
    this.messages.push(setupdata);
    this.len = this.messages.length;
  }

  getlastmessage() {
    return this.messages[this.len - 1];
  }

  setupdata(params) {
    const tempdata = {
      id: params.id,
      senderror : false,
      kodeunik : params.kodeunik,
      tiket_id: params.tiket_id,
      sender_id: params.sender_id,
      message: params.message,
      sent_at: params.sent_at,
      gambar_pengaduan_thumb: params.gambar_thumb,
      gambar_pengaduan: params.gambar,
      file_pengaduan: params.file,
      sender: {
        id: params.sender_id,
        username: params.username,
        role_id: params.role_id,
        perusahaan: {
          id: params.id_perusahaan,
          users_id: params.user_id,
          nama_perusahaan: params.nama_perusahaan,
        },
      },
    };

    return tempdata;
  }

  updatestatus(newstatus) {
    this.status = newstatus;
  }
}
